import { render, staticRenderFns } from "./ListTag.vue?vue&type=template&id=5183d1d6&scoped=true&"
import script from "./ListTag.vue?vue&type=script&lang=js&"
export * from "./ListTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5183d1d6",
  null
  
)

export default component.exports